import type {SupabaseClient} from './supabaseTypes.js';
import {getRpcFormConfig, isRpcRequest} from './offlineRpcForms.js';

export async function submitQueuedRpc(sb: SupabaseClient, formKind: string, record: unknown, actorProfileId: string) {
  const config = getRpcFormConfig(formKind);
  if (!isRpcRequest(record) || record.rpc !== config.rpc) {
    return {data: null, error: {code: 'WCF01', message: 'The stored request needs help. Open it to review.'}};
  }
  const parent = record.args.parent_in;
  if (!parent || typeof parent !== 'object' || Array.isArray(parent)) {
    return {data: null, error: {code: 'WCF01', message: 'The stored parent needs help. Open it to review.'}};
  }
  const identity = parent as Record<string, unknown>;
  const {data, error} = await sb.rpc('submit_queued_rpc', {
    p_form_kind: formKind,
    p_args: record.args,
    p_actor_profile_id: actorProfileId,
    p_photo: record.photo ?? null,
  });
  if (error) return {data, error};
  if (
    !data ||
    data.ok !== true ||
    data.verified !== true ||
    data.receipt_version !== 1 ||
    data.form_kind !== formKind ||
    data.actor_profile_id !== actorProfileId ||
    data.id !== identity.id ||
    data.client_submission_id !== identity.client_submission_id
  ) {
    return {data: null, error: {code: 'WCF01', message: 'Could not verify this report was saved. Open it to review.'}};
  }
  return {data: data.result, error: null};
}
